import { selector } from '@/lib/selectors';

// Leaf selectors: nothing from domain/ is imported here at runtime, so any
// selector module can depend on this one without an import cycle.
export const organizationSelector = (state) => state.organization;
export const currentOrganizationSelector = selector(organizationSelector, (org) => org.currentOrganization);
